import { ActionHandler } from "..";
import { isAppAndroid, isFreemiumUpsellRoute } from "src/utils/userSegment";
import { isGlobalExitEnabled } from "src/utils/globalExit";
import { setGlobalExitAction } from "src/utils/redux/slices/globalExitConfiguration";
import { isInAppMedUpgrade } from "src/utils/userSegment/features";

export const setGlobalExitInUpsell: ActionHandler = async ({ store }) => {
  if (isGlobalExitEnabled() || !isAppAndroid()) {
    return;
  }
  if (!isFreemiumUpsellRoute() && !isInAppMedUpgrade()) {
    return;
  }

  store.dispatch(
    setGlobalExitAction({
      exitFreemiumUpsell: [],
    })
  );
};
